export const CATEGORY_INFOS = 'extendedSources'
export const CATEGORY_CHANCES = 'chances'
export const CATEGORY_RISKS = 'risks'
export const CATEGORY_UPDATES = 'updates'

export const CATEGORIES = [CATEGORY_INFOS, CATEGORY_CHANCES, CATEGORY_RISKS]
export const EXTENDED_CATEGORIES = [CATEGORY_INFOS, CATEGORY_CHANCES, CATEGORY_RISKS, CATEGORY_UPDATES]
